module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo_minor/lmi_vis-0e96518a3897305bb1f1412e7904a53f.jpg";